import{datasetFactory}from'../../../fc-core/src/lib';export default function(a){var b,c=a.getFromEnv('dataSource'),d=c.value,e=c.target,f=[],g={};f.push({value:d,target:e}),g.data=f,b=a.getDSdef(),datasetFactory(a,b,'dataset',1,[g])}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-widgets/src/factories/vled-dataset.js
// module id = null
// module chunks = 